module.exports = __webpack_public_path__ + "img/whatsapp-color.c73eb2b3.png";